import { FilterButton } from "components/components/Button/FilterButton";
import MarketViewFiltersForm from "components/components/balancingMechanism/marketView/MarketViewFiltersForm/MarketViewFiltersForm";
import { useMarketViewContext } from "contexts/MarketViewContext";
import useToggle from "hooks/useToggle";

import { hasAnyFilters } from "./helpers";
import { StyledDiv } from "./style";

interface Props {
  children: JSX.Element;
}

const MarketViewFilters: React.FC<Props> = ({ children }) => {
  const [showForm, toggleForm] = useToggle(false);
  const { bmuFilters } = useMarketViewContext();

  return (
    <StyledDiv className="container px-6">
      <h2>Time frame and filters</h2>
      <div>
        {children}
        <FilterButton
          onClick={toggleForm}
          isActive={hasAnyFilters(bmuFilters)}
          dataTestId="market-view-filters-button"
          buttonText="Filters"
        />
      </div>
      <MarketViewFiltersForm show={showForm} />
    </StyledDiv>
  );
};
export default MarketViewFilters;
